<template>
  <div class="public-long-desc">
    <md-card class="md-card-unspaced public-long-desc-card rfider-shadow">
      <md-card-content>
        <public-expand :item="item" refKey="longDescription"></public-expand>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import PublicExpand from '@/components/public/publicExpand.vue';

export default {
  components: {
    PublicExpand,
  },
  props: {
    item: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/public/_public-long-description.scss';
</style>
